import { useHistory } from 'react-router'
import React from 'react'
import { useMutation, useClient } from 'jsonapi-react'
import moment from 'moment'

import { Body } from 'layouts/basic'
import Button from 'components/Button'
import Input, { InputFile } from 'components/Forms/Input'
import Label from 'components/Forms/Label'
import Textarea from 'components/Forms/Textarea'
import Datetime from 'components/Forms/Datetime'
import { uploadFiles } from 'helpers'


export default function SceneEventsNew(props) {
  const history = useHistory()
  const [addEvent, { isLoading }] = useMutation([
    'events',
  ])
  const client = useClient()

  const [imageId, setImageId] = React.useState(null)
  const [isFileUploading, setIsFileUploading] = React.useState(false)

  const uploadFile = async e => {
    setIsFileUploading(true)

    const data = await uploadFiles(e.currentTarget.files, client)

    setImageId(data[0].id)

    setIsFileUploading(false)
  }

  const onSubmit = async (e) => {
    e.preventDefault()

    const title = e.currentTarget.elements[0].value
    const description = e.currentTarget.elements[1].value
    const startDatetime = moment(e.currentTarget.elements[5].value).format()
    const endDatetime = (
      e.currentTarget.elements[7].value ?
      moment(e.currentTarget.elements[7].value).format() :
      null
    )
    try {
      const event = await addEvent({
        title,
        description,
        startDatetime,
        endDatetime,
        image: {
          id: imageId,
          type: 'File',
        },
      })
      if (event.error) {
        throw event.error
      }
    } catch (error) {
      return
    }

    history.push('/account/events/')
  }

  return (
    <Body className='ml-auto mr-auto max-w-2xl w-full prose' loading={isLoading}>
      <h1>Create new Event</h1>
      <form onSubmit={onSubmit}>
        <Label>
          Title *
          <Input
            inputProps={{
              required: true,
              placeholder: 'Event Title',
            }}
          />
        </Label>
        <Label>
          Description *
          <Textarea
            inputProps={{
              required: true,
              placeholder: 'Event Description',
            }}
          />
        </Label>
        <Label>
          Thumbnail *
          <InputFile
            inputProps={{
              accept: 'image/jpg, image/png, image/jpeg',
              required: true,
            }}
            loading={isFileUploading}
            onChange={uploadFile}
          />
          <Input inputProps={{type: 'hidden'}} value={imageId} />
        </Label>
        <div className='sm:flex sm:space-x-5 block'>
          <Datetime clearable />
        </div>
        <div className='flex justify-between'>
          <Button disabled={isFileUploading} type='submit' className='rounded inverted'>Submit</Button>
          <Button
            type='reset'
            className='rounded inverted'
            theme='disabled'
            onClick={() => history.goBack()}
          >
            Cancel
          </Button>
        </div>
      </form>
    </Body>
  )
}
